export const fieldTypeOptions = [
    "Rating",
    "Grading",
    "eNPS",
    "Range",
    "Single choice group",
    "Multi-choice group",
    "Short text",
    "Long text"
];

export const explanationInfoText = "Allow user to explain their response?";
export const mandatoryInfoText = "Require the user to respond?";